const shortcutNames = {
  at: 'accessToken',
  rt: 'refreshToken',
  ate: 'accessTokenExp',
  rte: 'refreshTokenExp',
  uId: 'userId',
  cc: 'codeChallenge'
}

const spacer = ','

export const parse = cookie => {
  return cookie.split(spacer).reduce((acc, val) => {
    const vs = val.split('_')
    if (vs.length < 2 || !shortcutNames[vs[0]]) {
      return acc
    }

    return {
      ...acc,
      [shortcutNames[vs[0]]]: vs[1]
    }
  }, {})
}

export const stringify = obj => {
  return Object.keys(shortcutNames)
    .reduce((acc, k, index) => {
      const v = Object.values(shortcutNames)[index]
      if (!obj[v]) {
        return acc
      }

      return [...acc, `${[k]}_${obj[v]}`]
    }, [])
    .join(spacer)
}

export default {
  parse,
  stringify
}



// WEBPACK FOOTER //
// ./src/utils/authCookie.js